import React, { ComponentProps } from 'react';
import { Drawer, DrawerContent } from '@fiverr-private/overlay';

interface DrawerWrapperProps {
    isDrawerOpen: boolean;
    size: ComponentProps<typeof DrawerContent>['size'];
    children: React.ReactNode;
    closeDrawer: () => void;
}

const DrawerWrapper = ({ isDrawerOpen, size, children, closeDrawer }: DrawerWrapperProps) => (
    <Drawer isOpen={isDrawerOpen} onClose={closeDrawer} data-testid="drawer-wrapper">
        <DrawerContent overlayTestId="overlay-data-test-id" size={size || 'md'}>
            {children}
        </DrawerContent>
    </Drawer>
);

export default DrawerWrapper;
